export enum DriverRelationTypeEnum {
  'NO_APLICA' = 'No Aplica',
  'TERMINO_INDEFINIDO' = 'Término Indefinido',
  'OBRA_O_LABOR' = 'Obra o Labor',
  'PRESTACION_DE_SERVICIOS' = 'Prestación de Servicios',
  'APRENDIZAJE' = 'Aprendizaje',
  'OCACIONAL_DE_TRABAJO' = 'Ocacional de trabajo',
}
